// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_default_footer__4MPIy","footerContent":"footer_default_footerContent__OHMTQ","title":"footer_default_title__i6Ctr"};